;(function($) {

    var DatePicker = function($element, $options)
    {
        var generateDatePicker = function()
        {
            var $select, $title, $body, $left, $right, $back, $clear;
            var $template = $('<div class="itrm-datepicker">')
                .append(
                    $('<div class="itrm-datepicker-header">')
                        .append(
                            $left = $('<div class="itrm-datepicker-header-left"><i class="fa fa-chevron-left">'),
                            $('<div class="itrm-datepicker-header-middle">')
                                .append(
                                    $select = $('<select>')
                                ),
                            $right = $('<div class="itrm-datepicker-header-right"><i class="fa fa-chevron-right">')
                        ),
                    //$title = $('<div class="itrm-datepicker-title">'),
                    $body = $('<div class="itrm-datepicker-body">'),
                    $back = $('<div class="itrm-datepicker-back">').text('Back'),
                    $clear = $('<div class="itrm-datepicker-clear">').text('Clear')
                );

            $title = $('<div class="itrm-datepicker-title">');

            return {
                template: $template,
                select: $select,
                title: $title,
                body: $body,
                left: $left,
                right: $right,
                back: $back,
                clear: $clear
            };
        };

        var generateYears = function($year)
        {
            $year = Math.floor($year / 10) * 10;

            var $body = $('<div>');
            for (var $i = $year; $i <= $year + 9; ++$i)
            {
                var $yearElement = $('<div class="itrm-datepicker-year" data-type="year">');
                $yearElement.data('value', $i).text($i);

                if (!isValid($i + '', 'year'))
                {
                    $yearElement.addClass('disabled');
                }

                $body.append($yearElement);
            }

            return $body;
        };

        var generateMonths = function($year)
        {
            var $body = $('<div>');
            var $months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
            $months.forEach(function($month, $index) {

                var $monthElement = $('<div class="itrm-datepicker-month" data-type="month">');
                $monthElement.data('value', $index).text($month);

                if (!isValid(moment($year + '/' + ($index + 1), 'YYYY/MM'), 'month'))
                {
                    $monthElement.addClass('disabled');
                }

                $body.append($monthElement);
            });

            return $body;
        };

        var generateDays = function($days, $offset, $date)
        {
            var $body = $('<div>');
            var $titles = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

            $titles.forEach(function($title)
            {
                $body.append($('<div class="itrm-datepicker-day-title">').text($title));
            });

            for (var $i = 0; $i < $days; ++$i)
            {
                var $day = $('<div class="itrm-datepicker-day" data-type="day">');
                $day.data('value', $i).text($i + 1);

                if (!isValid(moment($date.getFullYear() + '/' + ($date.getMonth() + 1) + '/' + ($i + 1), 'YYYY/MM/DD')))
                {
                    $day.addClass('disabled');
                }

                if ($i < 1 && $offset > 0)
                {
                    $day.addClass('itrm-datepicker-pad-day-' + $offset);
                }

                $body.append($day);
            }

            return $body;
        };

        var getFormats = function($format)
        {
            var $formats = { year: 'YY', month: 'M', day: 'D' };

            var $usedFormats = {
                year: false,
                month: false,
                day: false
            };

            for (var x in $formats)
            {
                if ($format.indexOf($formats[x]) >= 0)
                {
                    $usedFormats[x] = true;
                }
            }

            return $usedFormats;
        };

        var $availableFormats = getFormats($options.format);
        var $this = this;
        var $momentDate = moment($element.val());
        var $date = $momentDate.isValid() ? $momentDate.toDate() : new Date();
        var $days = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
        var $months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        var $yearFrom = $options.minDate.getFullYear();
        var $yearTo = $options.maxDate.getFullYear();
        var $monthFrom = $options.minDate.getMonth();
        var $monthTo = $options.minDate.getMonth();
        var $view = 'day';

        var $picker = generateDatePicker();

        var $showing = false;

        this.show = function()
        {
            if ($showing)
            {
                return;
            }

            $showing = true;

            var $bounds = $element[0].getBoundingClientRect();
            var $windowHeight = window.innerHeight;
            var $pickerHeight = $picker.template.outerHeight();
            var $property = 'top';

            if ($pickerHeight < 10)
            {
                $pickerHeight = 250;
            }

            if ($windowHeight - $bounds.bottom < $pickerHeight)
            {
                $property = 'bottom';
            }

            $picker.template.css({
                top: 'auto',
                bottom: 'auto'
            });
            $picker.template.css($property, ($element.outerHeight(false) + 3) + 'px');
            $picker.template.insertAfter($element);

            var $momentDate = moment($element.val(), $options.format);


            $date = $momentDate.isValid() ? $momentDate.toDate() : null;

            if (!$date || $date < $options.minDate || $date > $options.maxDate)
            {
                $view = 'year';
                generateSelect('year');
                $date = new Date();
            } else if ($options.format === 'YYYY') {
                $view = 'year';
                generateSelect('year');
            }

            renderDate($date);
        };

        this.hide = function()
        {
            $picker.template.detach();
            $showing = false;
        };

        var isValid = function($date, $startOf)
        {
            if (!$startOf)
            {
                $startOf = 'day';
            }

            var $startDate = moment($date).startOf($startOf);

            return $startDate >= moment($options.minDate).startOf($startOf)
                && $startDate <= moment($options.maxDate).startOf($startOf);
        };

        var getDaysInMonth = function($date)
        {
            var month = $date.getMonth()+1;
            return new Date($date.getFullYear(), month, 0).getDate();
        };

        var getDayOffset = function($date)
        {
            var $dateOffset = new Date($date.getTime());
            $dateOffset.setDate(0);
            return $dateOffset.getDay() + 1;
        };


        var generateSelect = function($view)
        {
            $picker.select.html('');

            if ($view === 'year')
            {
                for (var $i = Math.floor(parseInt($yearFrom) / 10) * 10; $i <= $yearTo; $i += 10)
                {
                    $picker.select.append($('<option>').text($i + ' - ' + ($i + 9)).val($i));
                }
            }
            else if ($view === 'day')
            {

                var $currentYear = $date.getFullYear();
                for (var $i = $currentYear - 1; $i <= $currentYear + 1; ++$i)
                {
                    for (var $j = 0; $j < 12; ++$j)
                    {
                        if (($i > $yearTo || ($i == $yearTo && $j > $monthTo)) || ($i < $yearFrom || ($i == $yearFrom && $j < $monthFrom)))
                        {
                            continue;
                        }

                        $picker.select.append($('<option>').val($i + '-' + ($j + 1)).text($months[$j] + ' - ' + $i));
                    }
                }
            }
            else
            {
                for (var $i = $yearFrom; $i <= $yearTo; ++$i)
                {
                    $picker.select.append($('<option>').text($i));
                }
            }
        };


        if ($availableFormats.day)
        {
            $view = 'day';
        }
        else if ($availableFormats.month)
        {
            $view = 'month';
        }
        else if ($availableFormats.year)
        {
            $view = 'year';
        }


        generateSelect($view);

        var renderDate = function($date)
        {
            var $selectYear = 0;

            switch ($view)
            {
                case 'year':
                    var $year = Math.floor(parseInt($date.getFullYear()) / 10) * 10;
                    $picker.body.html('').append(generateYears($year));
                    $picker.title.text(($year) + ' - ' + ($year + 9));
                    $selectYear = $year;
                    break;

                case 'month':
                    $picker.body.html('').append(generateMonths($date.getFullYear()));
                    $picker.title.text($date.getFullYear());
                    $selectYear = $date.getFullYear();
                    break;

                case 'day':
                    $picker.body.html('').append(generateDays(getDaysInMonth($date), getDayOffset($date), $date));
                    $picker.title.text($months[$date.getMonth()]);
                    $selectYear = $date.getFullYear() + '-' + ($date.getMonth() + 1);
                    break;
            }

            $picker.select.val($selectYear);
        };

        renderDate($date);

        $picker.left.on('click picker:click', function() {

            var $newDate = new Date($date.getTime());
            switch ($view)
            {
                case 'year':
                    $newDate.setFullYear($newDate.getFullYear() - 10);
                    break;

                case 'month':
                    $newDate.setFullYear($newDate.getFullYear() - 1);
                    break;

                case 'day':
                    $newDate.setMonth($newDate.getMonth() - 1);
                    break;
            }

            if (isValid($newDate))
            {
                $date = $newDate;

                if ($view === 'day')
                {
                    generateSelect('day');
                }
            }

            renderDate($date);
            //console.log('left', $date);
        });

        $picker.right.on('click picker:click', function() {

            var $newDate = new Date($date.getTime());

            switch ($view)
            {
                case 'year':
                    $newDate.setFullYear(Math.floor(parseInt($newDate.getFullYear() + 10) / 10) * 10);
                    break;

                case 'month':
                    $newDate.setFullYear($newDate.getFullYear() + 1);
                    $newDate.setMonth(0);

                    if ($newDate.getFullYear() == $yearFrom)
                    {
                        $newDate.setMonth($monthFrom);
                    }

                    break;

                case 'day':
                    $newDate.setMonth($newDate.getMonth() + 1);
                    break;
            }

            if (isValid($newDate))
            {
                $date = $newDate;

                if ($view === 'day')
                {
                    generateSelect('day');
                }
            }

            renderDate($date);
            //console.log('right', $date);
        });

        $picker.select.change(function() {
            var $value = $(this).val();
            var $originalValue = $(this).val();
            if ($view === 'day')
            {
                $date.setMonth(parseInt($value.substring(5)) - 1);
                $value = $value.substring(0, 4);
            }
            $date.setFullYear($value);
            renderDate($date);

            if ($view === 'day')
            {
                generateSelect('day');
                $(this).val($originalValue);
            }
        });

        var $backUp = function() {

            if ($view === 'day')
            {
                $view = 'month';
                //renderDate($date);
                generateSelect();
            }
            else if ($view === 'month')
            {
                $view = 'year';
                //renderDate($date);
                generateSelect('year');
            }


            renderDate($date);
        };

        $picker.title.click($backUp);
        $picker.back.click($backUp);

        var $clearField = function() {
            $element.val('');
            $element.trigger('change');
        };

        $picker.clear.click($clearField);


        var insertFormattedDate = function($date)
        {
            $element.val(moment($date).format($options.format));
            $element.trigger('change');
        };

        $picker.body.on('click', '[data-type="day"]:not(.disabled)', function() {
            $date.setDate($(this).data('value') + 1);
            insertFormattedDate($date);
            $this.hide();
        });

        $picker.body.on('click', '[data-type="month"]:not(.disabled)', function() {
            var $month = $(this).data('value');

            $date.setMonth($month, 1);

            if ($availableFormats.day)
            {
                $view = 'day';
                renderDate($date);
                generateSelect('day');
                $picker.select.val($date.getFullYear() + '-' + ($month + 1));
            }
            else
            {
                insertFormattedDate($date);
                $this.hide();
            }
        });

        $picker.body.on('click', '[data-type="year"]:not(.disabled)', function() {
            var $year = $(this).data('value');
            $date.setFullYear($year);
            generateSelect();

            if ($availableFormats.month)
            {
                $view = 'month';
                renderDate($date);
            }
            else
            {
                insertFormattedDate($date);
                $this.hide();
            }
        });

        var $mouseOverPicker = false;

        $picker.template.on('mouseenter', function()
        {
            $mouseOverPicker = true;
        });

        $picker.template.on('mouseleave', function()
        {
            $mouseOverPicker = false;
        });

        $picker.select.on('click', function()
        {
            $mouseOverPicker = true;
        });

        var $elementFocused = false;

        $element.keydown(function(e)
        {
            switch (e.which) {

                case 8:
                    if ($showing) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        $('.itrm-datepicker-back', $picker.template).trigger('click');
                    }
                    return;

                case 27:
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $this.hide();
                    return;

                case 13:
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    if ($showing) {
                        $mouseOverPicker = true;
                        $('.active[data-type]', $picker.body).trigger('click');
                    } else {
                        $this.show();
                    }
                    return;

                case 38:
                case 40:

                    e.preventDefault();

                    var $up = e.which == 38;
                    var $down = !$up;
                    if (!$showing) {
                        return;
                    }
                    var $count = $('[data-type]', $picker.body).length;
                    //console.log($count);

                    if (!$('.active[data-type]', $picker.body).length) {
                        $('[data-type]', $picker.body).first().addClass('active');
                        return;
                    }

                    if ($down) {
                        var $next = $('.active[data-type]', $picker.body).removeClass('active').next('[data-type]:visible:not(.disabled)');
                        if (!$next.length) {
                            $next = $('[data-type]:not(.disabled)', $picker.body).first();
                        }

                        $next.addClass('active');
                    }

                    if ($up) {
                        var $prev = $('.active[data-type]', $picker.body).removeClass('active').prev('[data-type]:visible:not(.disabled)');
                        if (!$prev.length) {
                            $prev = $('[data-type]:not(.disabled)', $picker.body).last();
                        }
                        $prev.addClass('active');
                    }

                    return;

                case 37:
                case 39:
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    e.which == 37
                        ? $picker.left.trigger('picker:click')
                        : $picker.right.trigger('picker:click');
                    return;
            }
        });

        $element.focus(function(e) {
            $elementFocused = true;
            $element.parents('[data-toggle]').tooltip('destroy');
            $this.show();
        });

        $element.blur(function(e) {
            $elementFocused = false;
            if (!$mouseOverPicker)
            {
                $element.parents('[data-toggle]').tooltip();
                $this.hide();
            }
        });

        $(document).click(function(e) {
            if (!$mouseOverPicker && e.target !== $element[0])
            {
                $this.hide();
            }
        });
    };

    var $minDate = new Date();
    $minDate.setFullYear(1900);

    var $defaultOptions = {
        format: 'DD/MM/YYYY',
        maxDate: new Date(),
        minDate: $minDate
    };

    $.fn.datepicker = function($options)
    {
        return this.each(function ()
        {
            var $this = $(this);
            if (!$this.data('itrm-datepicker'))
            {
                $options = $.extend(true, {}, $defaultOptions, $options);
                $this.data('itrm-datepicker', new DatePicker($this, $options));
            }
        });
    };

}($));